import {useEffect, useMemo} from "react";
import {useImmer} from "use-immer";
import useFetchParcels from "./useFetchParcels";

function useParcelsWithHulls(sessionId, machines, parcelUpdateTimestamps, isEnabled) {

    const TAG = "HULLS";

    const [hulls, updateHulls] = useImmer({});
    const [savedParcelTimestamps, updateSavedParcelTimestamps] = useImmer({});
    
    const machinesArray = useMemo(() => Array.isArray(machines) ? machines : [machines], [machines]);
    const machineNames = useMemo(() => machinesArray.map(m => m.name), [machinesArray]);

    const changedParcels = useMemo(() => {
        if (!sessionId || !isEnabled) {
            return [];
        }
        if (parcelUpdateTimestamps) {
            console.log(TAG, "1. parcel update timestamps", parcelUpdateTimestamps);
            const result = Object.keys(parcelUpdateTimestamps).filter(name => (savedParcelTimestamps[name] && savedParcelTimestamps[name] !== parcelUpdateTimestamps[name]));
            console.log(TAG, "2. parcel update timestamps result", result);
            return result;
        } else {
            return [];
        }
    }, [sessionId, isEnabled, parcelUpdateTimestamps, savedParcelTimestamps]);


    const requestMachineNames = useMemo(() => {
        if (!sessionId || !isEnabled) {
            return [];
        }
        if (changedParcels.length > 0) {
            return changedParcels;
        } else {
            return machineNames.filter(name => !name.startsWith("stage") && !name.startsWith("vpa"));
        }
    }, [changedParcels, isEnabled, machineNames, sessionId]);


    useEffect(() => {
        if (!sessionId || !isEnabled) {
            return;
        }
        if (!parcelUpdateTimestamps) {
            return;
        }
        console.log(TAG, "3. saving parcel update timestamps", parcelUpdateTimestamps);
        updateSavedParcelTimestamps(draft => {
            for (const key of Object.keys(parcelUpdateTimestamps)) {
                draft[key] = parcelUpdateTimestamps[key];
            }
        });
    }, [isEnabled, parcelUpdateTimestamps, sessionId, updateSavedParcelTimestamps]);

    
    // useEffect(() => {
    //     if (!sessionId || !isEnabled) {
    //         return;
    //     }
    //     const hullKeys = Object.keys(hulls);
    //     console.log(TAG, "hull keys", hullKeys);
    // }, [hulls, isEnabled, sessionId]);


    const [data, isLoading, error] = useFetchParcels(sessionId, requestMachineNames);

    useEffect(() => {
        console.log(TAG, "is loading?", isLoading);
        console.log(TAG, "error?", error);
        console.log(TAG, "data", data);
        if (data && !isLoading && !error) {
            updateHulls(draft => {
                for (const key of Object.keys(data)) {
                    draft[key] = data[key];
                }
            });
        }
    }, [data, error, isLoading, updateHulls]);

    return [hulls, isLoading];
}

export default useParcelsWithHulls
